import React from 'react'
import {Flex} from '/app/src/component'

export default class Tabs extends React.Component{
    render(){
        return (
            <Flex column grow h='100%'>
                <Flex h='70px' w='100%' backgroundColor='black' shrink={0}>
                    {this.props.header.map((btn, index)=>{
                    return  <Flex key={index} grow center cursor='pointer'> {btn} </Flex>
                    })}
                </Flex>
                {this.props.body.map((tabBody, index) => {
                    return (
                        <Flex h='100%' w='100%' key={index} style={{display: this.props.active===index?'flex': 'none'}} overflowY='auto'>
                            {tabBody}
                        </Flex>
                    )
                })}
            </Flex>
        )
    }
}



// WEBPACK FOOTER //
// ./src/component/Tabs/index.js